import {
  Box,
  Calendar1Icon,
  Card,
  CheckFilledIcon,
  GKButton,
  Grid2,
  Typography,
} from "components";
import GKEditorViewer from "components/GKEditorViewer";
import { useFormContext, useWatch } from "react-hook-form";
import { useAppSelector } from "store/store";
import { ThemeContainer } from "utils/Theme";
import { WebsiteDetails } from "../types";

const AboutMeSection = () => {
  const { theme } = ThemeContainer();

  const form = useFormContext<WebsiteDetails>();

  const croppedYoutubeThumbnail = useAppSelector(
    (state) => state?.myWebsite?.croppedYoutubeThumbnail,
  );

  const focusedField = useAppSelector(
    (state) => state?.myWebsite?.focusedField,
  );

  const [aboutMe, heroSection] = useWatch({
    control: form.control,
    name: ["websiteSection.aboutMe", "websiteSection.heroSection"],
  });

  return (
    <Grid2
      container
      width={"100%"}
      spacing={10}
      overflow={"hidden"}
      maxWidth={{ xs: "100vw", md: "1192px" }}
    >
      <Grid2
        size={{ xs: 12, md: 6 }}
        position={"relative"}
        container
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Grid2 size={12} textAlign={"center"} position={"relative"}>
          <img
            width={"80%"}
            style={{ borderRadius: 16 }}
            src={
              croppedYoutubeThumbnail ||
              (aboutMe?.youtubeThumbnail as string) ||
              "/Logos/errorImg.svg"
            }
            alt=""
          />
          <GKButton
            style={{
              position: "absolute",
              transform: "translate(-50%, -50%)",
              top: "50%",
              left: "50%",
              background: "#00000044",
              height: "100%",
              width: "100%",
              borderRadius: 16,
            }}
            target="_blank"
          >
            <img src={"/youtubeIcon.svg"} alt="" />
          </GKButton>
        </Grid2>
      </Grid2>

      <Grid2
        size={{ xs: 12, md: 6 }}
        display={"flex"}
        alignContent={"center"}
        container
        spacing={2}
      >
        <Grid2 size={12}>
          <Typography
            fontSize={12}
            color="#697586"
            fontWeight={600}
            textTransform={"uppercase"}
            textAlign={{ xs: "center", md: "left" }}
            letterSpacing={"0.6px"}
          >
            ABOUT Analyst
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Typography
            fontWeight={600}
            textAlign={{ xs: "center", md: "left" }}
            border={
              focusedField === "websiteSection.heroSection.advisorName"
                ? "2px solid #007bff"
                : undefined
            }
          >
            {heroSection?.advisorName}
          </Typography>
        </Grid2>
        <Grid2
          size={12}
          sx={{
            "& .ck p": {
              textAlign: {
                xs: "center",
                md: "left",
              },
              fontSize: "16px !important",
              lineHeight: "25px",
            },
            "& .ck": {
              fontSize: "16px !important",
              lineHeight: "25px",
            },
          }}
          borderRadius={
            focusedField === "websiteSection.aboutMe.advisorInfo"
              ? 2
              : undefined
          }
          border={
            focusedField === "websiteSection.aboutMe.advisorInfo"
              ? "2px solid #007bff"
              : undefined
          }
        >
          <GKEditorViewer id="about-advisor" content={aboutMe?.advisorInfo} />
        </Grid2>
        <Grid2 size={12}>
          <Card
            sx={{
              background: "#ffffff",
              border: "1px solid var(--neutral-100)",
              borderRadius: 2,
            }}
          >
            <Grid2 container spacing={{ xs: 2, md: 2 }}>
              <Grid2 container size={{ xs: 12, md: 6 }} gap={1}>
                <Grid2 size={"auto"} display={"flex"} alignItems={"center"}>
                  <Box
                    bgcolor={`${theme.palette.info.main}22`}
                    p={1}
                    display={"flex"}
                    alignItems={"center"}
                    borderRadius={33}
                  >
                    <Calendar1Icon color={theme.palette.info.main} />
                  </Box>
                </Grid2>
                <Grid2 size={"auto"}>
                  <Typography fontSize={12} fontWeight={40}>
                    Years of experience{" "}
                  </Typography>
                  <Typography
                    fontSize={18}
                    fontWeight={600}
                    borderRadius={
                      focusedField ===
                      "websiteSection.aboutMe.yearsOfExperience"
                        ? 2
                        : undefined
                    }
                    border={
                      focusedField ===
                      "websiteSection.aboutMe.yearsOfExperience"
                        ? "2px solid #007bff"
                        : undefined
                    }
                  >
                    {aboutMe?.yearsOfExperience} Years
                  </Typography>
                </Grid2>
              </Grid2>
              <Grid2 container size={{ xs: 12, md: 6 }} gap={1}>
                <Grid2 size={"auto"} display={"flex"} alignItems={"center"}>
                  <Box
                    p={1}
                    display={"flex"}
                    borderRadius={33}
                    alignItems={"center"}
                    bgcolor={`${theme.palette.success.main}22`}
                  >
                    <CheckFilledIcon color={theme.palette.success.main} />
                  </Box>
                </Grid2>
                <Grid2 size={"auto"}>
                  <Typography fontSize={12} fontWeight={40}>
                    SEBI Registered
                  </Typography>
                  <Typography
                    fontSize={18}
                    fontWeight={600}
                    borderRadius={
                      focusedField === "websiteSection.aboutMe.sebiRegistered"
                        ? 2
                        : undefined
                    }
                    border={
                      focusedField === "websiteSection.aboutMe.sebiRegistered"
                        ? "2px solid #007bff"
                        : undefined
                    }
                  >
                    {aboutMe?.sebiRegistered}
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
          </Card>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default AboutMeSection;
